import UseScreenSize from '@/hooks/UseScreenSize';
import UseThemeColors from '@/hooks/UseThemeColors';
import React from 'react';
import classNames from './PageWrap.module.scss';
import classes from 'classnames';

const PageWrap = ({ children, isTeacher }: { children: React.ReactNode; isTeacher?: boolean }) => {
  const { color } = UseThemeColors();
  const { isMobile } = UseScreenSize();

  return (
    <div
      style={{
        backgroundColor: color('pageBackground'),
        position: 'relative',
      }}
      className={classes(
        'w-full flex flex-1 flex-col',
        isMobile ? 'gap-4 pt-14' : 'gap-10',
        'p-3',
        {
          [classNames.teacherContent]: isTeacher && !isMobile,
        }
      )}
    >
      {children}
    </div>
  );
};

export default PageWrap;
